import React from "react";

const FormItemTotal = ({ total }) => {
  return (
    <div className="col-span-3 flex flex-col-reverse">
      <input
        type="text"
        value={"$" + total.toFixed(2)}
        disabled={true}
        className="w-full p-2 border border-gray-300 rounded text-end cursor-not-allowed"
      />
      <span className="font-bold text-xs text-center">Total</span>
    </div>
  );
};

export default FormItemTotal;
